var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevistaOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.26,
    height: 20.234,
    viewBox: "0 0 22.26 20.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,3.5H9.078A5.058,5.058,0,0,1,14.13,8.552V22.734a1,1,0,1,1-2,0,2.041,2.041,0,0,0-2.039-2.039H3a1,1,0,0,1-1-1V4.5A1,1,0,0,1,3,3.5Zm9.13,15.748V8.552A3.055,3.055,0,0,0,9.078,5.5H4V18.695h6.091A4.015,4.015,0,0,1,12.13,19.248Z",
    transform: "translate(0)",
    fill: "#c2c4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.052,3.5H28.13a1,1,0,0,1,1,1V19.695a1,1,0,0,1-1,1H21.039A2.041,2.041,0,0,0,19,22.734a1,1,0,1,1-2,0V8.552A5.058,5.058,0,0,1,22.052,3.5Zm5.078,2H22.052A3.055,3.055,0,0,0,19,8.552v10.7a4.015,4.015,0,0,1,2.039-.553H27.13Z",
    transform: "translate(-4.87)",
    fill: "#c2c4d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevistaOff);
export default __webpack_public_path__ + "static/media/Revista-Off.a97e59397401bbff61c79312d1d33f84.svg";
export { ForwardRef as ReactComponent };